/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SupplementalAnswerType = {
    Radio: 'radio',
    Select: 'select',
    Text: 'text'
} as const;
export type SupplementalAnswerType = typeof SupplementalAnswerType[keyof typeof SupplementalAnswerType];


export function SupplementalAnswerTypeFromJSON(json: any): SupplementalAnswerType {
    return SupplementalAnswerTypeFromJSONTyped(json, false);
}

export function SupplementalAnswerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalAnswerType {
    return json as SupplementalAnswerType;
}

export function SupplementalAnswerTypeToJSON(value?: SupplementalAnswerType | null): any {
    return value as any;
}

